import { colors, styles } from '../styles/styles';

export const fieldEditPageStyles = {
    container: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        padding: styles.spacing.md,
        backgroundColor: colors.background,
        zIndex: 10,
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        maxHeight: '100vh',
        animation: 'fadeIn 0.3s cubic-bezier(0.2, 0, 0, 1)',
        willChange: 'opacity',
    },

    header: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: styles.spacing.lg,
        paddingLeft: 0,
        maxWidth: '800px',
        margin: `0 auto ${styles.spacing.lg}`,
        width: '100%',
    },

    backButton: {
        backgroundColor: 'transparent',
        border: 'none',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        padding: styles.spacing.sm,
        marginLeft: 0,
    },

    title: {
        margin: 0,
        fontSize: styles.typography.h3.fontSize,
        fontWeight: styles.typography.fontWeightBold,
        flex: 1,
        textAlign: 'center',
        color: colors.textPrimary,
        marginLeft: 0,
    },

    saveButton: (isSaving) => ({
        backgroundColor: colors.accent.white,
        color: 'black',
        border: 'none',
        borderRadius: styles.borderRadius.xl,
        padding: `${styles.spacing.sm} ${styles.spacing.md}`,
        cursor: isSaving ? 'default' : 'pointer',
        opacity: isSaving ? 0.7 : 1,
        fontSize: styles.typography.label.fontSize,
        fontWeight: styles.typography.fontWeightMedium,
        position: 'relative',
        paddingLeft: isSaving ? styles.spacing.xl : styles.spacing.md,
        display: 'flex',
        alignItems: 'center',
    }),

    savingSpinner: {
        position: 'absolute',
        left: styles.spacing.sm,
        width: '14px',
        height: '14px',
        borderRadius: '50%',
        border: '2px solid rgba(255,255,255,0.3)',
        borderTopColor: '#fff',
        animation: 'spin 1s linear infinite',
    },

    content: {
        flex: 1,
        overflowY: 'auto',
        overflowX: 'hidden',
        paddingBottom: styles.spacing.lg,
        maxWidth: '800px',
        margin: '0 auto',
        width: '100%',
    },

    fieldEditor: {
        importance: {
            container: {
                marginTop: styles.spacing.xl,
            },
            label: {
                display: 'block',
                marginBottom: styles.spacing.md,
                fontWeight: styles.typography.fontWeightMedium,
                fontSize: styles.typography.body.fontSize,
                color: colors.textSecondary,
            },
            optionsContainer: {
                width: '100%',
                marginBottom: styles.spacing.lg,
            },
            optionsList: {
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                gap: styles.spacing.md,
            },
            optionButton: (isSelected) => ({
                display: 'flex',
                alignItems: 'center',
                padding: `${styles.spacing.sm} ${styles.spacing.md}`,
                backgroundColor: isSelected ? 'rgba(0, 122, 255, 0.1)' : colors.surfaceElevated,
                border: isSelected ? '1px solid #007AFF' : `1px solid ${colors.divider}`,
                borderRadius: styles.borderRadius.md,
                cursor: 'pointer',
                transition: styles.transitions.fast,
            }),
            optionText: (isSelected) => ({
                flex: 1,
                textAlign: 'left',
                fontSize: styles.typography.body.fontSize,
                color: colors.textPrimary,
                fontWeight: isSelected ? styles.typography.fontWeightMedium : styles.typography.fontWeightRegular,
            }),
            levelIndicator: {
                width: '32px',
                height: '32px',
                borderRadius: '50%',
                backgroundColor: '#FFFFFF',
                color: '#1A1F36',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: '600',
                marginRight: styles.spacing.sm,
                border: '1px solid #E5E9EF',
            },
        },

        comments: {
            container: {
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: colors.background,
                zIndex: 20,
            },
            header: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: styles.spacing.md,
                maxWidth: '800px',
                margin: '0 auto',
                width: '100%',
            },
            content: {
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                maxWidth: '800px',
                margin: '0 auto',
                width: '100%',
                padding: `0 ${styles.spacing.md}`,
                overflowY: 'auto',
            },
            thoughtDisplay: {
                backgroundColor: colors.surfaceElevated,
                padding: styles.spacing.md,
                margin: `${styles.spacing.md} 0`,
                borderRadius: styles.borderRadius.md,
            },
            thoughtText: {
                fontSize: '15px',
                lineHeight: '1.5',
                color: colors.textPrimary,
                whiteSpace: 'pre-wrap',
            },
            textareaContainer: {
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                padding: `0 0 ${styles.spacing.md} 0`,
                marginBottom: styles.spacing.md,
            },
            textarea: {
                flex: 1,
                border: 'none',
                padding: styles.spacing.md,
                fontSize: '15px',
                lineHeight: '1.5',
                resize: 'none',
                outline: 'none',
                backgroundColor: colors.surfaceElevated,
                color: colors.textPrimary,
                borderRadius: styles.borderRadius.md,
                minHeight: '250px',
                fontFamily: 'inherit',
                whiteSpace: 'pre-wrap',
            },
        },
    },

    animations: {
        '@keyframes spin': {
            '0%': { transform: 'rotate(0deg)' },
            '100%': { transform: 'rotate(360deg)' },
        },
    },
}; 